'use strict';
import React from 'react';

var LoginBackgroundVideo = React.createClass({
    displayName: 'LoginBackgroundVideo',
    mixins: [],
    propTypes: {
        video: React.PropTypes.string.isRequired,
        poster: React.PropTypes.string,
        positionX: React.PropTypes.string,
        positionY: React.PropTypes.string
    },
    getInitialState() {
        return {
            videoWidth: 'auto',
            videoHeight: 'auto',
            videoVisibility: 'hidden',
            // wrapperBackgroundImage: 'url(' + this.props.poster + ')',
            wrapperBackgroundImage: 'none'
        };
    },
    getDefaultProps() {
        return {
            positionX: '50%',
            positionY: '50%'
        };
    },
    _resize() {
        if (this.refs.video) {
            var video = this.refs.video.getDOMNode();
            var wrapper = this.refs.wrapper.getDOMNode();

            // Get a native video size
            var videoHeight = video.videoHeight;
            var videoWidth = video.videoWidth;

            // Get a wrapper size
            var wrapperHeight = wrapper.offsetHeight;
            var wrapperWidth = wrapper.offsetWidth;

            if (wrapperWidth / videoWidth > wrapperHeight / videoHeight) {
                this.setState({videoWidth: wrapperWidth + 2, videoHeight: 'auto'});
            } else {
                this.setState({videoWidth: 'auto', videoHeight: wrapperHeight + 2});
            }

        }
    },
    _isPlaying() {
        this.setState({wrapperBackgroundImage: 'none', videoVisibility: 'visible'});
    },
    componentWillUnmount() {
        if (this.refs.video) {
            var video = this.refs.video.getDOMNode();
            video.removeEventListener('canplaythrough', this._resize);
            video.removeEventListener('playing', this._isPlaying);
            window.removeEventListener('resize', this._resize);
        }
    },
    componentDidMount() {
        this._resize();
        if (this.refs.video) {
            var video = this.refs.video.getDOMNode();
            video.addEventListener('canplaythrough', this._resize);
            video.addEventListener('playing', this._isPlaying);
            window.addEventListener('resize', this._resize);
        }
    },
    render() {
        var positionX = this.props.positionX;
        var positionY = this.props.positionY;

        var wrapperStyle = {
            'backgroundPosition': positionX + ' ' + positionY,
            'backgroundImage': this.state.wrapperBackgroundImage
        };

        var videoStyle = {
            top: positionX,
            left: positionY,
            width: this.state.videoWidth,
            height: this.state.videoHeight,
            visibility: this.state.videoVisibility,
            'WebkitTransform': 'translate(-' + positionX + ', -' + positionY + ')',
            'MsTransform': 'translate(-' + positionX + ', -' + positionY + ')',
            'MozTransform': 'translate(-' + positionX + ', -' + positionY + ')',
            transform: 'translate(-' + positionX + ', -' + positionY + ')'
        };

        return (
            <div ref="wrapper" className="login__video" style={wrapperStyle}>
                <video ref="video" style={videoStyle} autoPlay="true" loop="true" volume="0" muted="true">
                    <source src={this.props.video} type="video/mp4" />
                </video>
            </div>);
    }
});

module.exports = LoginBackgroundVideo;



// WEBPACK FOOTER //
// ./app/pages/login/loginBackgroundVideo.js